import { createSelector } from '@ngrx/store';
import { selectLoggedInUserState, selectSiteMapState } from '../reducers';
import {
  selectClients,
  selectCurrentClient,
  selectCurrentClientId,
  selectIsClientsLoading,
} from './client.selector';
import { selectIsLoggedInUserLoading } from './logged-in-user.selector';
import { selectShowClientSelector } from './page-header.selectors';
import {
  selectIsResellersLoading,
  selectResellers,
  selectSelectedReseller,
} from './reseller.selectors';
import { selectIsSiteMapLoading } from './site-map.selector';
import { selectIsEditing } from './status.selector';

export const selectIsUserContextLoaded = createSelector(
  selectClients,
  selectLoggedInUserState,
  selectResellers,
  selectSiteMapState,
  (clients, loggedInUserState, resellers, _siteMapState) => {
    return (
      !!clients &&
      clients.length > 0 &&
      !!loggedInUserState &&
      !!resellers &&
      resellers.length > 0
      //  &&
      // !!siteMapState &&
      // siteMapState.siteMaps.ids.length > 0
    );
  },
);

/**
 * Select the logged in user's state with their
 * associated clients.
 */
export const selectLoggedInUserWithClients = createSelector(
  selectLoggedInUserState,
  selectClients,
  (loggedInUserState, clients) => {
    return {
      loggedInUserState,
      clients,
    };
  },
);

export const selectCurrentUserAndClient = createSelector(
  selectLoggedInUserState,
  selectCurrentClientId,
  (loggedInUserState, selectedClientId) => {
    return {
      user: loggedInUserState.ftUser,
      clientId: selectedClientId,
    };
  },
);

export const selectShowClientSelectorInHeader = createSelector(
  selectShowClientSelector,
  selectIsEditing,
  (showClientSelector, isEditing) => showClientSelector && !isEditing,
);

export const selectClientsPerReseller = createSelector(
  selectClients,
  selectResellers,
  (clients, resellers) => {
    const result: Record<number, typeof clients> = {};
    resellers.forEach((reseller) => {
      result[reseller.id] = clients.filter(
        (c) =>
          !!c.customerKey &&
          (reseller.id === null ||
            c.resellerId === null ||
            c.resellerId === reseller.id),
      );
    });
    return result;
  },
);

export const selectCurrentFilteringContext = createSelector(
  selectCurrentClient,
  selectSelectedReseller,
  (currentClient, currentReseller) => ({ currentClient, currentReseller }),
);

export const selectIsContextLoading = createSelector(
  selectIsClientsLoading,
  selectIsLoggedInUserLoading,
  selectIsResellersLoading,
  selectIsSiteMapLoading,
  (
    isClientsLoading,
    isLoggedInUserLoading,
    isResellersLoading,
    isSiteMapLoading,
  ) =>
    isClientsLoading &&
    isLoggedInUserLoading &&
    isResellersLoading &&
    isSiteMapLoading,
);
